import React, { useEffect } from "react";
import { Route, Switch, Router } from "react-router-dom";
import { Redirect } from "react-router";
import Login from "../components/Login/Login";
import Home from "../components/Home/Home";
import NotFound from "../components/shared/NotFound";
import Error from "../components/shared/Error";
import { selectAuthenticate } from "../../state/ducks/login/index";
import { history } from '../../utilities/history';
import { connect } from "react-redux";
import LoadingOverlay from 'react-loading-overlay'
import { ClipLoader } from "react-spinners";
import ForgotPassword from "../components/Login/ForgotPassword";
import NewMember from "../components/NewMember/NewMember";
import NewMemberSave from "../components/NewMember/NewMemberSave";
import NewMemberDone from "../components/NewMember/NewMemberDone";
import PaymentSuccess from "../components/shared/PaymentSuccess";
import PaymentFailed from "../components/shared/PaymentFailed";
import { AxiosErrorHandler } from '../../services/base.service'
import { ToastContainer, toast } from "react-toastify";

const AppRouter = ({ login }) => {
  const loggedIn = login?.loggedIn;

  return (
    <AxiosErrorHandler>
      <Router history={history}>
        <LoadingOverlay active={false} spinner={<ClipLoader />} styles={{
          overlay: (base) => ({
            ...base,
            background: 'rgba(0, 0, 0, 0.02)'
          }),
          content: (base) => ({
            ...base
          })
        }}>
          <Switch>
            <Route exact path="/" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <Login {...props} />} />
            <Route path="/giris/:type" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <Login {...props} />} />
            <Route path="/giris" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <Login {...props} />} />
            <Route path="/Home/:page" render={(props) => loggedIn ? <Home {...props} /> : <Login {...props} />} />
            <Route path="/sifremiunuttum/:type" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <ForgotPassword {...props} />} />
            <Route path="/sifremiunuttum/" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <ForgotPassword {...props} />} />
            <Route path="/yeniuyelik/" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <NewMember {...props} />} />
            <Route path="/yeniuyelikkod/" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <NewMemberSave {...props} />} />
            <Route path="/yeniuyelikbasarili/" render={(props) => loggedIn ? <Redirect to="/Home/Dashboard" /> : <NewMemberDone {...props} />} />
            <Route path="/Error" render={(props) => <Error {...props} />} />
            <Route path="/PaymentSuccess" render={(props) => <PaymentSuccess {...props} />} />
            <Route path="/PaymentFailed" render={(props) => <PaymentFailed {...props} />} />
            <Route component={NotFound}></Route>
          </Switch>
          <ToastContainer
            position="top-right"   // konum: top-right, top-center, bottom-left vb.
            autoClose={5000}       // 3 saniye sonra otomatik kapanır
            hideProgressBar={true}
            newestOnTop
            closeOnClick
            pauseOnHover
            theme="colored"        // seçenekler: "light", "dark", "colored"
          />
        </LoadingOverlay>
      </Router>
    </AxiosErrorHandler>
  );
};

const mapStateToProps = state => {
  return {
    login: selectAuthenticate(state)
  };
};

export default connect(mapStateToProps)(AppRouter);
